import mixpanel from 'mixpanel-browser';

let env_check = process.env.useMixPanel;

mixpanel.init('6b8207ba6184e51bad067dbf7f12ed6b', {debug: !env_check, ignore_dnt: true});

let actions = {
    identify: (id) => {
        if (env_check) mixpanel.identify(id);
    },
    alias: (id) => {
        if (env_check) mixpanel.alias(id);
    },
    track: (name, props) => {
        if (env_check) {
            mixpanel.track(name, props);
        }
    },
    people: {
        set: (props) => {
            if (env_check) mixpanel.people.set(props);
        },
    },
};

export let Mixpanel = actions;
